import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotosComponent } from './photos/photos.component';
import { LogosComponent } from './logos/logos.component';
import { SiteWebComponent } from './site-web/site-web.component';
import { ReseauxSociauxComponent } from './reseaux-sociaux/reseaux-sociaux.component';
import { DescriptionComponent } from './description/description.component';
import { ContenusComponent } from './contenus.component';
import { PanelModule } from 'primeng/panel';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {ToggleButtonModule} from 'primeng/togglebutton';
import { FormsModule } from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import { ErreursComponent } from './erreurs/erreurs.component'
import {MultiSelectModule} from 'primeng/multiselect';
import {CardModule} from 'primeng/card';
import { OffreComponent } from './offre/offre.component';
import {RouterModule, Routes} from '@angular/router';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToolbarModule } from 'primeng/toolbar';
import { DropdownModule } from 'primeng/dropdown';
import { SidebarModule } from 'primeng/sidebar';
import {NgxChronometerModule} from 'ngx-chronometer'
import { ToastModule } from 'primeng/toast';
import { ClipboardModule } from "ngx-clipboard";
import {StickyNavModule} from "ng2-sticky-nav"
import { BrowserModule } from '@angular/platform-browser';
import {CheckboxModule} from 'primeng/checkbox';
import {CountdownModule} from 'ngx-countdown';
import {ColorPickerModule} from 'primeng/colorpicker';

@NgModule({
  declarations: [PhotosComponent, LogosComponent, SiteWebComponent, ReseauxSociauxComponent, DescriptionComponent, ContenusComponent, ErreursComponent, OffreComponent],
  imports: [
    CommonModule,
    PanelModule,
    InputTextareaModule,
    ToggleButtonModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    MultiSelectModule,
    CardModule,
    RouterModule,
    OverlayPanelModule,
    RadioButtonModule,
    ToolbarModule,
    SidebarModule,
    DropdownModule,
    NgxChronometerModule,
    ToastModule,
    ClipboardModule,
    BrowserModule,
    StickyNavModule,
    CheckboxModule,
    CountdownModule,
    ColorPickerModule
  ],
  exports: [
    PhotosComponent, ReseauxSociauxComponent, DescriptionComponent, OffreComponent, ErreursComponent
  ]
})
export class ContenusModule { }
